import React from "react";
import { Helmet } from "react-helmet-async";
import { HERO_LOGO_URL, TAGLINES } from "./constants";

/**
 * Per-page SEO + Open Graph + Twitter Card meta.
 *
 * Pass a per-page title + description + optional canonical path. Falls back
 * to sensible defaults so unmounted/no-arg usage still does the right thing
 * for crawlers and link unfurlers (iMessage, WhatsApp, Slack, etc.).
 */
export default function Seo({
  title,
  description,
  path = "",
  image,
  type = "website",
}) {
  const SITE = "https://sistersignal.org";
  const fullTitle = title ? `${title} · Sister Signal` : `Sister Signal — ${TAGLINES.primary}`;
  const desc =
    description ||
    "A private emotional safety companion. Decode confusing messages, understand relationship patterns, and build a safety plan with care.";
  const url = `${SITE}${path}`;
  const img = image || HERO_LOGO_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph — iMessage / WhatsApp / Facebook / LinkedIn */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Sister Signal" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Theme color tuned to the blush gradient */}
      <meta name="theme-color" content="#fff3f6" />
    </Helmet>
  );
}
